<div fxLayoutAlign="start center">
  <mat-chip class="mur-roster" (click)="showList = !showList" [ngClass]="roster.length > capacity ? 'mur-roster-crowded' : 'mur-roster'" matTooltip="Number of current editors">
    <div fxLayoutAlign="center center" fxLayoutGap="5px">
      <mat-icon>person</mat-icon>

      @if (!showList) {
        <span>{{ roster.length }}</span>
      }

      @if (showList) {
        <div fxLayoutGap="10px">
          @for (user of roster; track user) {
            <mat-label>{{ user }}</mat-label>
          }
        </div>
      }
    </div>
  </mat-chip>
</div>
